import { useMemo } from 'react';
import { useGoal } from '../../../../hooks/useGoal';
import { AsyncComponentHookResult } from '../../../../../../Types/ComponentHookResult';
import { RothConversionChartDataDTO } from './RothConversion.types';

export const useRothConversion = (): AsyncComponentHookResult<RothConversionChartDataDTO> => {
  const queryResult = useGoal();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const goal = queryResult.data;

    if (!goal) {
      return null;
    }

    const { GoalCharts } = goal;

    if (!GoalCharts || !Array.isArray(GoalCharts)) {
      return null;
    }

    const chartData = GoalCharts.find(({ Title }) => Title === 'Roth Conversion');

    if (!chartData) {
      return null;
    }

    return (chartData.Data as unknown) as RothConversionChartDataDTO;
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
